











































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import { Blog, Business, Role } from "@/types";

const { mapActions: blogActions, mapGetters: blogGetters } =
  createNamespacedHelpers("BLOG_");
const { mapActions: categoryActions, mapGetters: categoryGetters } =
  createNamespacedHelpers("BLOG_CATEGORY_");

const API_URL = process.env.VUE_APP_API_URL;

export default Vue.extend({
  name: "BlogPost",
  props: {
    id: {
      type: String,
      required: false,
    },
    slug: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      appUrl: API_URL,
    };
  },
  computed: {
    ...blogGetters(["getBlog"]),
    ...categoryGetters(["categoryPage"]),
    role(): Role {
      return this.$store.getters.role;
    },
    blog(): Blog | undefined {
      return this.id ? this.getBlog(this.id) : undefined;
    },
    isAdmin(): boolean {
      return true;
    },
  },
  methods: {
    ...blogActions(["fetchBlog", "fetchBlogBySlug"]),
    ...categoryActions(["fetchCategoryList"]),
    getCategoryName(categoryId: string): string {
      if (!this.categoryPage?.docs) return categoryId;

      const category = this.categoryPage.docs.find((c) => c._id === categoryId);
      return category ? category.name : categoryId;
    },
    goBack() {
      this.$router.go(-1);
    },
    editBlog() {
      if (this.blog) {
        this.$router.push(`/blog/edit/${this.blog._id}`);
      }
    },
    formatDate(dateString: string): string {
      if (!dateString) return "";

      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    getBusinessId(): string {
      if (!this.role || !this.role.business) return "";

      return typeof this.role.business === "string"
        ? this.role.business
        : (this.role.business as Business)._id;
    },
  },
  mounted() {
    if (this.role && this.id) {
      const businessId = this.getBusinessId();
      if (businessId) {
        this.fetchBlog({ businessId, blogId: this.id });
        this.fetchCategoryList({ businessId });
      }
    } else if (this.role && this.slug) {
      const businessId = this.getBusinessId();
      if (businessId) {
        this.fetchBlogBySlug({ businessId, slug: this.slug });
        this.fetchCategoryList({ businessId });
      }
    }
  },
  watch: {
    id(newId) {
      if (newId && this.role) {
        const businessId = this.getBusinessId();
        if (businessId) {
          this.fetchBlog({ businessId, blogId: newId });
          this.fetchCategoryList({ businessId });
        }
      }
    },
    slug(newSlug) {
      if (newSlug && this.role) {
        const businessId = this.getBusinessId();
        if (businessId) {
          this.fetchBlogBySlug({ businessId, slug: newSlug });
          this.fetchCategoryList({ businessId });
        }
      }
    },
  },
});
